module.exports = require("core-js-pure/stable/instance/sort");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js-stable/instance/sort.js
// module id = 6487
// module chunks = 25